// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2YyBq","footer":"Form_footer__3DsTo"};